// theme.js
import { createTheme } from '@mui/material/styles';

// Define your modern color palette
const modernPalette = {
    primary: {
        main: '#2979ff', // A slightly less saturated blue
        light: '#75a7ff',
        dark: '#004ecb',
        contrastText: '#fff',
    },
    secondary: {
        main: '#f44336', // A modern red accent
        light: '#ff7961',
        dark: '#ba000d',
        contrastText: '#fff',
    },
    background: {
        default: '#f8f9fa', // Light gray background for light mode
        paper: '#fff', // White background for paper/cards in light mode
    },
    text: {
        primary: 'rgba(0, 0, 0, 0.87)', // Slightly lighter primary text
        secondary: 'rgba(0, 0, 0, 0.6)', // Muted secondary text
    },
    // Add error, warning, info, success colors if needed
};

const darkModernPalette = {
    primary: {
        main: '#90caf9', // Lighter blue for dark mode
        light: '#c3fdff',
        dark: '#5c6bc0',
        contrastText: 'rgba(0, 0, 0, 0.87)', // Dark text on light primary
    },
    secondary: {
        main: '#ffab91', // Lighter orange/red for dark mode
        light: '#ffddc1',
        dark: '#c87b64',
        contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    background: {
        default: '#121212', // Dark gray background for dark mode
        paper: '#1e1e1e', // Slightly lighter gray for paper/cards in dark mode
    },
    text: {
        primary: '#fff', // White primary text for dark mode
        secondary: 'rgba(255, 255, 255, 0.7)', // Muted white secondary text
    },
};


export const lightTheme = createTheme({
  palette: modernPalette,
  typography: {
    fontFamily: "'Nunito', sans-serif", // Example: Using Nunito font
    // Customize other typography settings like h1, h2, body1, body2, etc.
  },
  shape: {
    borderRadius: 8, // Default rounded corners for components
  },
  components: {
      MuiAppBar: {
          styleOverrides: {
              root: {
                  backgroundColor: modernPalette.background.paper, // Ensure AppBar uses paper background in light mode
                  color: modernPalette.text.primary, // Ensure AppBar text uses primary text color in light mode
              }
          }
      }
  }
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    ...darkModernPalette, // Spread the dark modern palette
  },
  typography: {
    fontFamily: "'Nunito', sans-serif",
  },
  shape: {
    borderRadius: 8,
  },
   components: {
      MuiAppBar: {
          styleOverrides: {
              root: {
                  backgroundColor: darkModernPalette.background.paper, // Ensure AppBar uses paper background in dark mode
                  color: darkModernPalette.text.primary, // Ensure AppBar text uses primary text color in dark mode
              }
          }
      }
  }
});